import { render } from "./DeleteAssociationModal.vue?vue&type=template&id=d5dc9ffc&scoped=true"
import script from "./DeleteAssociationModal.vue?vue&type=script&lang=js"
export * from "./DeleteAssociationModal.vue?vue&type=script&lang=js"

import "./DeleteAssociationModal.vue?vue&type=style&index=0&id=d5dc9ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5dc9ffc"]])

export default __exports__